import { useEffect, type ReactNode } from "react";
import { X } from "lucide-react";

export function Modal({ open, title, children, onClose, size = "md" }: { open: boolean; title: string; children: ReactNode; onClose: () => void; size?: "sm" | "md" | "lg" | "xl" }) {
  useEffect(() => {
    if (!open) return;
    const previous = document.body.style.overflow;
    const close = (event: KeyboardEvent) => { if (event.key === "Escape") onClose(); };
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", close);
    return () => { document.body.style.overflow = previous; document.removeEventListener("keydown", close); };
  }, [onClose, open]);
  if (!open) return null;
  return <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className={`modal modal-${size}`} role="dialog" aria-modal="true" aria-labelledby="cce-modal-title">
      <header className="modal-header"><div><span className="eyebrow">CCE Gestão</span><h2 id="cce-modal-title">{title}</h2></div><button className="icon-button" onClick={onClose} aria-label="Fechar"><X size={20}/></button></header>
      <div className="modal-body">{children}</div>
    </section>
  </div>;
}
